// this is an autogenerated file from DesignSystem/CheckIn/query_check_in_notes.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CheckIn($patient_id: uuid!) {
  vaxiom_notes(
    where: {
      patient: { _id: { _eq: $patient_id } }
      target_type: { _eq: "Patient.CheckIn" }
    }
  ) {
    id
    note
    sys_created
    author_user {
      id
      person {
        id
        first_name
        middle_name
        last_name
      }
    }
  }
}

`